import {createSlice} from '@reduxjs/toolkit';

const upcomingModalSlice = createSlice({
  name: 'upcomingModal',
  initialState: {
    vehicle: '',
    vehicleSN: '',
    machineType: '',
    task: '',
    overdue: false,
    upcoming: false,
    inspectionFailure: false,
    breakdownReport: false,
    intervalString: '',
    dueString: '',
    noHistory: false,
    lastCompletedDate: '',
    lastCompletedTimeDiff: '',
    reviewedBy: '',
    lastCompletedOdometer: '',
    lastCompletedEngineHours: '',
    serviceTask: {},
    // Implement service fields
    isImplementItem: false,
    implement: '',
    implementSN: '',
    currentImplementUsageHours: 0,
    lastCompletedImplementUsageHours: '',
    // Active service entry (for status/priority workflow)
    activeServiceEntry: null,
    unsafeToOperate: false,
  },
  reducers: {
    setInitialValues(state, action) {
      const taskData = action.payload;
      state.vehicle = taskData.vehicle;
      state.vehicleSN = taskData.vehicleSN;
      state.machineType = taskData.machineType;
      state.task = taskData.task;
      state.overdue = taskData.overdue;
      state.upcoming = taskData.upcoming;
      state.inspectionFailure = taskData.inspectionFailure;
      state.breakdownReport = taskData.breakdownReport;
      state.intervalString = taskData.intervalString;
      state.dueString = taskData.dueString;
      state.noHistory = taskData.noHistory;
      state.lastCompletedDate = taskData.lastCompletedDate;
      state.lastCompletedTimeDiff = taskData.lastCompletedTimeDiff;
      state.reviewedBy = taskData.reviewedBy;
      state.lastCompletedOdometer = taskData.lastCompletedOdometer;
      state.lastCompletedEngineHours = taskData.lastCompletedEngineHours;
      state.currentOdometer = taskData.currentOdometer;
      state.currentEngineHours = taskData.currentEngineHours;
      state.serviceTask = taskData.serviceTask;
      state.unsafeToOperate = taskData.unsafeToOperate === true;
      // Implement service fields
      state.isImplementItem = taskData.isImplementItem || false;
      state.implement = taskData.isImplementItem ? taskData.vehicle : '';
      state.implementSN = taskData.isImplementItem ? taskData.vehicleSN : '';
      state.currentImplementUsageHours = taskData.currentImplementUsageHours || 0;
      state.lastCompletedImplementUsageHours = taskData.lastCompletedImplementUsageHours || '';
      // Active service entry (for status/priority workflow)
      state.activeServiceEntry = taskData.activeServiceEntry || null;
    },
  },
});

export const {setInitialValues} = upcomingModalSlice.actions;
export default upcomingModalSlice.reducer;
